<template>
  <div>
    <div class="blue" ref="brandConcept">
      <div>欢迎您来到岳泰兴医疗科技有限公司官方网站</div>
      <div>全国厂家热线：400-022-9558</div>
    </div>
    <div class="box">
      <div class="left_image">
        <img src="/status/logoytx.png">
      </div>
      <div class="middle">
        <div class="father_box" v-for="(item,index) in titleList" :key="index">
          <div class="choose">
            <span :class="menuIndex == index ? 'chooseIndex active' : 'chooseIndex'" @click="selectMenu(item)">{{ item.title }}</span>
            <div class="border_" v-if="menuIndex == index"></div>
          </div>

        </div>
      </div>
    </div>
<!--    <el-carousel  height="400px" arrow="never" v-if="menuIndex != 5 && menuIndex != 4 && menuIndex != -1">-->
<!--      <el-carousel-item v-for="(item,index) in swiperList" :key="index">-->
<!--        <div class="swiper_list">-->
<!--          <div class="swiper_text">-->
<!--            成为大健康行业佼佼者-->
<!--          </div>-->
<!--          <div class="swiper_title">-->
<!--            Becoming a leader in the big health industry-->
<!--          </div>-->
<!--          <div class="swiper_title2">-->
<!--            在国家“互联网+医疗健康“制度的指引下,持续推动技术创新和产品升级，秉承“用科技服务人类健康”的理念，推动世界医疗健康事业发展-->
<!--          </div>-->
<!--        </div>-->
<!--        <img :src="item" alt="">-->
<!--      </el-carousel-item>-->
<!--    </el-carousel>-->
<!--    <el-carousel height="600px" v-if="menuIndex != 5 && menuIndex != 4 && menuIndex != -1">-->
<!--      <el-carousel-item v-for="(item,index) in swiperNewList" :key="index">-->
<!--        <div :class="item.left ? 'swiper_new_list':'swiper_new_list right'">-->
<!--          <div class="swiper_text">-->
<!--            {{item.text}}-->
<!--          </div>-->
<!--          <div class="swiper_new_title" v-html="item.title">-->
<!--          </div>-->
<!--          <div class="swiper_new_title2">-->
<!--            了解更多-->
<!--          </div>-->
<!--        </div>-->
<!--        <img :src="item.img" alt="">-->
<!--      </el-carousel-item>-->
<!--    </el-carousel>-->
    <!-- 轮播图开始 -->
        <el-carousel height="600px" v-if="menuIndex != 1 &&menuIndex != 6 && menuIndex != 5 && menuIndex != -1">
          <el-carousel-item>
            <div class="swiper_side_content swiper_side_first">
              <div class="website_wrapper side_content_container">
                <div class="side_module">
                  <div class="module_title">智慧医疗，引领未来</div>
                  <div class="module_en_title">leading the future</div>
                  <div class="module_message">
                    <div>当医疗与科技的力量相互交融，创新便呼之欲出</div>
                    <div>当我们不断地寻求突破，探索未知，将为人类健康事业带来全新的可能和机遇</div>
                  </div>
                  <div class="module_more">查看更多</div>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="home_banner">
              <div class="swiper_side_content swiper_side_second">
                <div class="website_wrapper side_content_container">
                  <div class="side_module_second">
                    <div class="side_second_title">成为大健康行业佼佼者</div>
                    <div class="side_second_en_title">Becoming a leader in the big health industry</div>
                    <div class="side_second_msg">在国家“互联网+医疗健康“制度的指引下,持续推动技术创新和产品升级，秉承“用科技服务人类健康”的理念，推动世界医疗健康事业发展</div>
                    <div class="side_second_bg"></div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>


        </el-carousel>

    <!-- 轮播图结束 -->
  </div>
</template>

<script>
import  {swiperList} from '@/views/mock'
export default {
  name: "header_menu",
  data() {
    return {
      swiperList:swiperList,
      swiperNewList:[
        {
          img:'/newIndex/swiper1.jpg',
          text:'专业行业软件系统研发',
          title:'致力于为您提供专业的软件服务<br/>为品牌和商家提供从流量到变现的一站式解决方案',
          left:true,
        },
        {
          img:'/newIndex/swiper2.jpg',
          text:'专业行业软件系统研发',
          title:'致力于为您提供专业的软件服务<br/>为品牌和商家提供从流量到变现的一站式解决方案',
          left:false,
        }
      ],
      menuIndex: 0,
      titleList: [
        {title: '首页', url: 'index'},
        {title: '智慧导诊', url: 'intelligentGuidance'},
        {title: '品牌理念', url: 'brandConcept'},
        {title: '企业资讯', url: 'enterpriseInformation'},
        {title: '商务合作', url: 'businessCooperation'},
        {title: '核心产品', url: 'coreProduct'},
        {title: '人才招聘', url: 'talentRecruitment'},
        {title: '联系我们', url: 'contactUs'},
      ],
    }
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        console.log(val,'val')
        let index;
        if (val.name == 'index') {
          index = 0
        } else if (val.name == 'intelligentGuidance') {
          index = 1
        }else if (val.name == 'brandConcept') {
          index = 2
        } else if (val.name == 'enterpriseInformation' || val.name == 'enterpriseInformationInfo') {
          index = 3
        } else if (val.name == 'businessCooperation') {
          index = 4
        } else if (val.name == 'coreProduct' || val.name == 'coreProductInfo') {
          index = 5
        }else if (val.name == 'talentRecruitment' || val.name == 'recruitInfo') {
          index = 6
        }else if (val.name == 'contactUs') {
          index = 7
        }else {
          index = -1
        }
        this.menuIndex = index
        if(!val.query.slide){
          this.$refs.brandConcept.scrollIntoView({ behavior: 'smooth' });
        }

      },
      deep: true
    }
  },
  mounted(){

  },
  methods: {
    selectMenu(item, index) {
      let params = {};
      if(item.url == 'coreProduct'){
        params = {fid:0}
      }else {
        params = {}
      }
      this.$router.push({name: item.url,query:params});
    }
  }
}
</script>

<style scoped lang="scss">
.blue {
  //background: rgb(63, 170, 249);
  //color: white;
  color: black;
  padding: 20px 12% 20px 10%;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}

.box {
  //background-color: white;
  display: flex;
  background: rgb(63, 170, 249);
  align-items: center;
  justify-content: space-between;
  .left_image{
    padding-left: 10%;
    img{
      width: 160px;
    }
  }
  .middle {
    margin-right: 10%;
    //color: #15191D;
    color: white;
    font-weight: 600;
    white-space: nowrap;
    display: flex;
    justify-content: space-around;
    font-size: 18px;
    .choose {
      padding: 20px 40px;
    }
    .chooseIndex:hover {
      //color: #076691;
      cursor: pointer;
      color: black;
    }
    .chooseIndex{

    }
    .border_ {
      //background: #076691;
      background: black;
      //border: 1px solid #076691;
      border: 1px solid black;
      margin-top: 2px;
    }

    .active {
      //color: #076691;
      color: black;
    }
  }


}
//.el-carousel__item{
//  img{
//    width: 100%;
//    height: 430px;
//  }
//
//}
//::v-deep .el-carousel__button{
//  width: 10px;
//  height: 10px;
//  border-radius: 100%;
//  background: rgb(122,179,239);
//}
//.swiper_list{
//  border-radius: 14px;
//  padding: 18px;
//  position: absolute;
//  top: 20%;
//  right: 50%;
//  background: rgb(241,240,239);
//  .swiper_text{
//    font-size: 28px;
//    color: #02b2b5;
//    font-weight: 700;
//  }
//  .swiper_title{
//    color: #7c7c7c;
//    font-size: 22px;
//    margin: 20px 0 20px 0;
//  }
//  .swiper_title2{
//    font-size: 14px;
//    color: #888;
//    width: 500px;
//    margin-top: 10px;
//  }
//}
.el-carousel__item{
  img{
    width: 100%;
    height: 600px;
  }

}
.swiper_new_list{
  position: absolute;
  top: 30%;
  left: 15%;
  .swiper_text{
    font-size: 47px;
    color: rgb(0, 0, 0);
  }
  .swiper_new_title{
    font-size: 18px;
    color: rgb(102, 102, 102);
    margin-top: 30px;
    line-height: 30px;
  }
  .swiper_new_title2{
    background: rgba(22, 100, 255, 1);
    color: white;
    width: 150px;
    height: 50px;
    line-height: 50px;
    margin-top: 40px;
    border-radius: 4px;
    text-align: center;
  }
}
.right{
  left: 56%;
}









.swiper_side_first {
  background: url('/homeSwiper/swiper1.png');
}

.swiper_side_second {
  background: url('/homeSwiper/swiper2.png');
}

.swiper_side_content {
  position: relative;
  height: 600px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: default;

  .side_content_container {
    height: 600px;
    position: relative;

    .side_module {
      position: absolute;
      top: 178px;
      left: 17%;
      width: 576px;
      height: auto;
      color: #ffffff;

      .module_title {
        font: 60px '幼圆';
      }

      .module_en_title {
        font: 61px '微软雅黑';
        font-weight: 700;
      }

      .module_message {
        height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 14px;
        margin: 35px 0;
      }

      .module_more {
        margin-top: 60px;
        color: #02b2b5;
        background: #ffffff;
        width: 162px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
      }
    }

    .side_module_second {
      position: absolute;
      top: 193px;
      left: 16%;
      width: 500px;
      height: auto;
      font-family: '微软雅黑';

      .side_second_title {
        font-size: 50px;
        color: #02b2b5;
        font-weight: 700;
      }

      .side_second_en_title {
        color: #7c7c7c;
        font-size: 36px;
        margin: 25px 0 10px 0;
      }

      .side_second_msg {
        font-size: 14px;
        color: #888888;
        width: 400px;
        margin-top: 20px;
      }

      .side_second_bg {
        position: absolute;
        top: 50px;
        left: 440px;
        width: 243px;
        height: 289px;
        background: url('/homeSwiper/side2.png') 100% 100%;
      }
    }
  }
}
</style>
